import React from 'react';
import { Link } from 'react-router';
import { Translate, I18n } from 'react-redux-i18n';
import { LocalizedTitle } from '../../Head';
import { needsAuth } from '../../utils/authHoc';

import { CardTitle, CardBody, Plus } from '@ui/ShopCard/partials';
import Price from '../Price';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import './SpecialOffer.scss';

const PLAN = 'on-your-own-special';
const Special = () => (
  <div className="container-fluid new-style select-plan code-gray-girl-bg">
    <div className="md-container">
      <LocalizedTitle id="seo.special.title" />

      <Row>
        <Col xs={12} md={6} className="form-group">
          <Col xs={12} className="card card-green">
            <CardTitle>{I18n.t('offer.special.title')}</CardTitle>
            <CardBody>
              <Plus>
                <Translate value="offer.special.1" dangerousHTML />
              </Plus>
              <Plus>{I18n.t('offer.special.2')}</Plus>
              <Plus>{I18n.t('offer.special.3')}</Plus>
              <Plus>{I18n.t('offer.special.4')}</Plus>
              <Plus>{I18n.t('offer.special.5')}</Plus>
              <Plus>{I18n.t('offer.special.6')}</Plus>
              <Plus>{I18n.t('offer.special.7')}</Plus>
              <Plus>{I18n.t('offer.special.8')}</Plus>

              <Price
                plan={PLAN}
                customHint={I18n.t('offer.special.subscription')}
              />

              <Link
                className="btn btn-flat btn-flat-green btn-flat-rounded center-block"
                to={`/i/buy/${PLAN}`}
              >
                {I18n.t('offer.special.buy')}
              </Link>

              <Row className="delimiter gray-text">
                {I18n.t('offer.special.or')}
              </Row>

              <Link
                className="btn btn-flat btn-flat-gray btn-flat-rounded center-block"
                to="/i/snap"
              >
                {I18n.t('offer.special.skip')}
              </Link>
            </CardBody>
          </Col>
        </Col>
      </Row>
    </div>
  </div>
);

export default needsAuth(Special);
